
import { Component,Prop, BaseMixins } from '@/lib';
@Component({name:"hi-button-poptip"})
export default class HiButtonPoptip extends BaseMixins{
    @Prop({type:String, required:true}) buttonLabelKey:string;
    @Prop({type:String}) permission:string;
    @Prop({type:String, required:true}) popTipContent:string;

    ok(){
        this.$emit("click")
    }
}
